declare const _imbox: any;

export const toggleImbox = () => _imbox.push(['toggle']);
export const hideLauncher = () => _imbox.push(['hideLauncher']);
export const setDisplayName = (displayName: string) => _imbox.push(['changeName', displayName]);
export const openImboxFaqArticle = (articleId: string) => _imbox.push(['openFAQArticle', articleId]);
